import React from "react";
import { ArrowLeftIcon, ArrowRightIcon ,ExclamationCircleIcon} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {  payForShipmentAndPackMany, updateCart } from "../../redux/reducer/cartReducer";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const TwoRowButtons = ({ onclickPerv, onclickNext, isCartEmpty,activeStep , selectedCartIds,selectedAddressId,getCompany}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const direction = useLanguageDirection();
const handleClick = async () => {
  if (activeStep === 2) {
    try {
      await Promise.all(
        selectedCartIds.map((cartId) =>
          dispatch(
            updateCart({
              cartId,
              data: { addressID: selectedAddressId },
            })
          ).unwrap()
        )
      );
      onclickNext();
    } catch (err) {
      console.error("Failed to update carts:", err);
    }
  } else if (activeStep === 3) {
    try {
      const result = await dispatch(payForShipmentAndPackMany(selectedCartIds));
      if (result.meta.requestStatus === "fulfilled") {
        const paymentUrl = result.payload.data.paymentUrl;
        if (paymentUrl) {          
          window.location.href = paymentUrl;
        } else {
          alert("No payment URL returned.");
        }
      } else {
        alert(t("ErrorChooseShippingCompany"));
      }
    } catch (err) {
      console.error("Error:", err);
    }

  } else {
    onclickNext();
  }
};

    
    // console.log(selectedCartIds?.length)
    // console.log(Object.keys(getCompany || {}).length);
    // console.log((selectedCartIds?.length === Object.keys(getCompany || {}).length))
  return (
    <div className="flex justify-between w-full mt-5">
      <button
        onClick={onclickPerv}
        className="inline-flex items-center justify-center px-4 py-2 text-xs text-black transition duration-300 ease-in-out transform lg:px-6 lg:py-3 bg-custom-yellow rounded-custom sm:text-sm lg:text-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
      >
        <ArrowRightIcon className={`w-4 me-2 text-black ${direction === "ltr" && "rotate-180"}`} />
        {t("Previous")}
      </button>
      
      {/* Conditionally render the Next button based on isCartEmpty */}
      {(activeStep === 3 && (selectedCartIds?.length !== Object.keys(getCompany || {}).length)) ? (
          <span className="flex items-center text-xs text-red-700 lg:text-base">
            <ExclamationCircleIcon className="w-5 h-5 text-xs text-red-700 me-2 lg:text-base" />
            {t("ErrorChooseShippingCompany")}
          </span>
        ) : (activeStep === 2 && !selectedAddressId) ? (
          <span className="flex items-center text-xs text-red-700 lg:text-base">
            <ExclamationCircleIcon className="w-5 h-5 text-xs text-red-700 me-2 lg:text-base" />
            {t("ErrorSelectAddress")}
          </span>
        ) : (activeStep === 1 && !(!isCartEmpty && !(activeStep === 1 && selectedCartIds.length === 0))) ? (
          <span className="flex items-center text-xs text-red-700 lg:text-base">
            <ExclamationCircleIcon className="w-5 h-5 text-xs text-red-700 me-2 lg:text-base" />
            {t("ErrorSelectOrder")}
          </span>
        ) : (
          (
            (activeStep !== 2 && !isCartEmpty && !(activeStep === 1 && selectedCartIds?.length === 0)) ||
            (activeStep === 2 && selectedAddressId) ||
            (activeStep === 3 && (selectedCartIds?.length === Object.keys(getCompany || {}).length))
          ) && (
            <button
              onClick={handleClick}
              className="inline-flex items-center justify-center px-4 py-2 text-xs text-white transition duration-300 ease-in-out transform bg-black lg:px-6 lg:py-3 rounded-custom sm:text-sm md:text-base lg:text-sm xl:text-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
            >
              {t("next")}
              <ArrowLeftIcon className={`w-4 ms-2 text-white ${direction === "ltr" && "rotate-180"}`} />
            </button>
          )
        )}

    </div>
  );
};

export default TwoRowButtons;
